import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IQueryReportListColumnResponse } from './query-report';
import { TabViewModule } from 'primeng/primeng';
import { TabView } from 'primeng/primeng';
import { TabPanel } from 'primeng/primeng';

import { QueryReportService } from '../query-reports/query-report.service';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';

import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';

import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
import { UIChart} from 'primeng/primeng';
import * as _ from 'lodash';

@Component({
    template: require('./query-reports-graph-display.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, UIChart]
})

export class QueryReportGraphDisplayComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;
    private sub: any;    
    msgs: Messages[]=[];

    currentScenario: IScenario;
    allScenarios: IScenario[];

    tableName: string;
    displayName: string;
    locId: string;
    airportName: string;
    graphType: string = "bar";

    startYear: number;
    endYear: number;

    columns: IQueryReportListColumnResponse[];

    result: any;
    data: any;
    quickGraph: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _queryReportService: QueryReportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService) {
    }

    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.displayName = params['displayName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
                this.graphType = params['graphType'];
                this.startYear = params['startYear'];
                this.endYear = params['endYear'];
                this.quickGraph = params['quickGraph'];
                
                this.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));

                this.getGraphData();
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
    }


    getGraphData(){

        let params = {
            tableName: this.tableName,
            locId: 0,
            scenarioId: this.User.getSession().scenarioId,
            startYear: this.startYear,
            endYear: this.endYear,
            columns: this.columns
        }

        this._queryReportService.getFacilityListReport(params)
            .subscribe(
                result => {
                    this.result = result;

                    this.createGraphDataSet();
                }
            );
    }

    createGraphDataSet(){

        let labels = _.map(this.result,'AYEAR');
        let datasets: any[] = [];

        for(let index in this.columns)
        {
            let dataset = {
                    label: this.columns[index].graphName,
                    data: _.map(this.result, this.columns[index].graphName),
                    fill: false,
                    
                    backgroundColor: this.getRandomColor(),
                    borderColor: this.getRandomColor()
            }

            datasets[index] = dataset;
        }
        
        this.data = {
           labels: labels,
           datasets: datasets
        }

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        
        for (let i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
    }

}



/** WEBPACK FOOTER **
 ** ./app/query-reports/query-reports-graph-display.component.ts
 **/